module.exports = __webpack_public_path__ + "img/medium-electric-pole.4bc9962a.png";